import type { DimensionMode } from "@v2/features/modifiers/base/DimensionSelector";
import type { DimensionModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import HeightModifier from "./HeightModifier";
import WidthModifier from "./WidthModifier";

interface ContainerSizeModifierProps {
  onWidthChange: (modifiers: DimensionModifierValue[]) => void;
  onHeightChange: (modifiers: DimensionModifierValue[]) => void;
  heightExcludeOptions?: DimensionMode[];
}

const ContainerSizeModifier: React.FC<ContainerSizeModifierProps> = ({
  onWidthChange,
  onHeightChange,
  heightExcludeOptions = [],
}) => {
  return (
    <div className="grid w-full grid-cols-2 gap-2">
      <div className="flex min-w-0 flex-col gap-1">
        <span className="text-2xs font-medium text-muted">Width</span>
        <WidthModifier onChange={onWidthChange} />
      </div>
      <div className="flex min-w-0 flex-col gap-1">
        <span className="text-2xs font-medium text-muted">Height</span>
        <HeightModifier
          onChange={onHeightChange}
          excludeOptions={heightExcludeOptions}
        />
      </div>
    </div>
  );
};

export default ContainerSizeModifier;
